import { useQuery } from '@tanstack/react-query';
import { ChartSettings } from '../../../chart-settings/model';
import { getThroughputMonitoredServices } from '../../api';
import {
  mapThroughputMonitoredServiceApiModelToThroughputMonitoredServiceViewModel,
  ThroughputMonitoredServiceViewModel
} from '../../model';
import { ThroughputMonitoredServiceQuery } from "../../config";
import { useAuthorizedAxios } from '../../../../core/hooks';
import { isValidCustomerId } from '../../../../customers';

interface ThroughputMonitoredServicesApiResponse {
  throughputMonitoredServices?: ThroughputMonitoredServiceViewModel[] | null;
  isFetching: boolean;
  isFetched: boolean;
}

export const useThroughputMonitoredServicesApiGet = (
  customerId: number | null,
  chartSettings: ChartSettings
): ThroughputMonitoredServicesApiResponse => {
  const axios = useAuthorizedAxios();
  const { data, isFetching, isFetched } = useQuery<ThroughputMonitoredServiceViewModel[] | null, Error>({
    queryKey: [
      ThroughputMonitoredServiceQuery['GetThroughputMonitoredServices'].key,
      customerId,
      chartSettings.timespan
    ],
    queryFn: async () => {
      if (customerId === null) {
        return null;
      } else {
        const throughputMonitoredServices = await getThroughputMonitoredServices(axios, { customerId, timespan: chartSettings.timespan });
        return mapThroughputMonitoredServiceApiModelToThroughputMonitoredServiceViewModel(throughputMonitoredServices);
      }
    },
    enabled: isValidCustomerId(customerId),
    gcTime: 30000,
    staleTime: 1000,
    structuralSharing: false
  });
  return {
    throughputMonitoredServices: data,
    isFetching,
    isFetched
  };
};